var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurprised1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM6.5 10.75C6.91421 10.75 7.25 10.4142 7.25 10C7.25 9.30964 7.80964 8.75 8.5 8.75C9.19036 8.75 9.75 9.30964 9.75 10C9.75 10.4142 10.0858 10.75 10.5 10.75C10.9142 10.75 11.25 10.4142 11.25 10C11.25 8.48122 10.0188 7.25 8.5 7.25C6.98122 7.25 5.75 8.48122 5.75 10C5.75 10.4142 6.08579 10.75 6.5 10.75ZM13.5 10.75C13.9142 10.75 14.25 10.4142 14.25 10C14.25 9.30964 14.8096 8.75 15.5 8.75C16.1904 8.75 16.75 9.30964 16.75 10C16.75 10.4142 17.0858 10.75 17.5 10.75C17.9142 10.75 18.25 10.4142 18.25 10C18.25 8.48122 17.0188 7.25 15.5 7.25C13.9812 7.25 12.75 8.48122 12.75 10C12.75 10.4142 13.0858 10.75 13.5 10.75ZM12 19C13.6569 19 15 17.6569 15 16C15 14.3431 13.6569 13 12 13C10.3431 13 9 14.3431 9 16C9 17.6569 10.3431 19 12 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurprised1);
export default __webpack_public_path__ + "static/media/surprised-1.3157376f236c266e6194d5c952711965.svg";
export { ForwardRef as ReactComponent };